import { render, staticRenderFns } from "./Ac2Queues.vue?vue&type=template&id=2079a905&scoped=true"
import script from "./Ac2Queues.vue?vue&type=script&lang=js"
export * from "./Ac2Queues.vue?vue&type=script&lang=js"
import style0 from "./Ac2Queues.vue?vue&type=style&index=0&id=2079a905&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2079a905",
  null
  
)

export default component.exports